<template>
    <div :class="'box-action-container relative rounded px-3 md:px-6 py-5 my-2 ' + getApparenceClasses">
        <div class="box-action-content flex flex-col md:flex-row justify-between items-center">
            <div :class="'box-action-text w-full flex-1 text-left mb-2 md:mb-0 ' + getTextClasses" v-html="text"></div>
            <div class="box-action-button w-full flex-1 flex-end">
                <div class="pl-0 md:pl-3">
                    <button 
                        :data-testid="getDataTestid"
                        :class="getButtonClasses"
                        @click.prevent="handleClick"
                    >{{ label }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            text: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            appareance: {
                type: String,
                default: 'instant-connection',
                validator: function(value) {
                    return ['instant-connection', 'manual-connection'].indexOf(value) !== -1;
                }
            }
        },
        methods: {
            handleClick() {
                this.$emit('click');
            }
        },
        data() {
            return {}
        },
        computed: {
            getDataTestid() {
                return this.label.toLowerCase();
            },
            getButtonClasses() {
                const instant = 'bg-terciary text-white py-5 rounded-full w-full p-1';
                const manual = 'bg-white text-black py-5 rounded-full  border-2 border-black  w-full p-1';

                return this.appareance === 'instant-connection' ? instant : manual;
            },
            getApparenceClasses() {
                const instant = 'gradient-2 text-black';
                const manual = 'text-primary bg-white';

                return this.appareance === 'instant-connection' ? instant : manual;
            },
            getTextClasses() {
                const instant = 'text-black font-semibold';
                const manual = 'text-black font-semibold';

                return this.appareance === 'instant-connection' ? instant : manual;
            }
        }
    }
</script>
